module.exports = __webpack_public_path__ + "static/media/logo-without-label.ba4f1120.png";